import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/loader.min.css'
import 'semantic-ui-css/components/segment.min.css'
import { fetchStaticPage } from '../../store/staticPage'
import Helmet from 'react-helmet'
import Ad from '../components/Ad'
import FORMATS from '../components/AdFormats'
import NotFound from './NotFound'
import IonArticle from 'ion-article'
import { ImageOrNoImage } from 'ion-image'
import NoImage from '../static/no-image.png'

export class StaticPage extends Component {
  componentDidUpdate (prevProps) {
    if (!this.props.hasError || prevProps.page !== this.props.page) {
      if (!this.props.staticPage || prevProps.page !== this.props.page) {
        this.props.fetchStaticPage(this.props.page)
      }
    }
  }

  UNSAFE_componentWillMount () {
    if (!this.props.hasError) {
      const lastFetch = new Date(this.props.lastFetch || 0)
      const now = new Date()

      // The store is shared by every static page route: refetch if it holds another page.
      if (!this.props.staticPage || this.props.pageName !== this.props.page || (now - lastFetch > 60000 * 60)) {
        this.props.fetchStaticPage(this.props.page)
      }
    }
  }

  render () {
    const proposedArticles = []
    if (this.props.latestArticles) {
      const lengthArray = this.props.latestArticles.length < 9 ? this.props.latestArticles.length : 9
      for (let i = 0; i < lengthArray; i++) {
        if (this.props.latestArticles[i].contentKey !== this.props.contentKey) {
          proposedArticles.push(new IonArticle(this.props.latestArticles[i]))
        }
      }
    }
    if (proposedArticles.length > 8) {
      proposedArticles.pop()
    }
    if (this.props.hasError) {
      return (
        <div className='content-wrapper'>
          <Helmet title='ERROR' />
          <p>Error: {this.props.error}</p>
        </div>
      )
    }
    if (this.props.hasFetched && this.props.staticPage && this.props.pageName === this.props.page) {
      const page = this.props.staticPage
      if (page.body) {
        return (
          <div className='wrapper static-page'>
            <Helmet title={this.props.title}>
              <meta name='description' content={this.props.description} />
            </Helmet>
            <h1>{page.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: page.body }} />
            {(this.props.page === 'subscriptions' || this.props.page === 'masthead' || this.props.page === 'terms-and-conditions' || this.props.page === 'privacy-policy') &&
              <div className='related-articles'>
                {proposedArticles.length > 0 && (
                  <h2>You might also like</h2>
                )}
                {
                  proposedArticles.map((proposedArticle, index) => {
                    return (
                      <article key={index}>
                        <Link to={'/' + proposedArticle.getCanonicalUri()}>
                          <ImageOrNoImage image={proposedArticle.getImageObject()} width='240' shape='square' alt={proposedArticle.headline} noImage={NoImage} />
                          <h3>
                            {proposedArticle.headline}
                          </h3>
                        </Link>
                      </article>
                    )
                  })
                }
              </div>}
          </div>
        )
      } else {
        return (
          <>
            <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${this.props.page}`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} collapseEmptyDiv className='advert-leaderboard-1' {...FORMATS.leaderboard} />
            <NotFound />
            <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${this.props.page}`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} collapseEmptyDiv className='advert-leaderboard-3' {...FORMATS.leaderboard} />
          </>
        )
      }
    } else {
      return (
        <>
          <Helmet title='Article' />
          <Segment>
            <Dimmer active>
              <Loader indeterminate size='large'>Loading Article</Loader>
            </Dimmer>
          </Segment>
        </>
      )
    }
  }
}
const mapStateToProps = (state) => (state.staticPage)
const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchStaticPage }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(StaticPage)
